import { getUser } from '../AppServices';
import { MODELS } from '../Lib/constants';
import { getUserRole } from '../Lib/helpers';

export const listAllUri = ({ filter = {}, params, navigation } = {}) => {
  let addOnFilter = {};

  const userRole = getUserRole();

  if (userRole === 'dealer') {
    addOnFilter = { madeByName: getUser().username };
  }

  if (navigation?.state?.params?.item) {
    addOnFilter = { madeByName: navigation?.state?.params?.item?.username };
  }

  return {
    query: {
      id: 'appraisalHistoryQuery',
      addOnFilter,
    },
    aggregate: true,
    model: MODELS.AVGenerationHistory,
  };
};

export const viewUri = ({ navigation }) => {
  return {
    query: {
      model: MODELS.AVGenerationHistory,
      id: 'appraisalHistoryQuery',
      relationValue: {
        model: MODELS.AVGenerationHistory,
        _id: navigation?.state?.params?.item?._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: MODELS.AVGenerationHistory,
  };
};
